<app-modal-confirmation class="d-flex flex-column h-100">
  <ng-template appCustomModalHeader>
    <ng-container
      *ngTemplateOutlet="
        deviceType === 'mobile' ? mobileTemp : desktopTemp
      "
    >
    </ng-container>
    <ng-template #desktopTemp>
      <div class="modal-header">
        <h4 class="fs-lg-u7 fs-u3 fw-bold mb-0 mx-2">
          {{ header || 'COMMON.Confirm' | translate }}
        </h4>
        @if (!headerCloseButton) {
          <button
            aria-label="Close"
            class="btn btn-std-outline-black-light btn-icon mx-3"
            type="button"
            (click)="onDismissClick()"
          >
            <span class="far fa-times fa-lg"></span>
          </button>
        }
      </div>
    </ng-template>
    <ng-template #mobileTemp>
      <div
        class="modal-header d-block border-0 pb-0 pt-base-u0 px-base-u0"
      >
        @if (!headerCloseButton) {
          <button
            aria-label="Close"
            class="btn btn-std-outline-black-light btn-icon"
            type="button"
            (click)="onDismissClick()"
          >
            <span class="far fa-arrow-left"></span>
          </button>
        }
        <h4 class="fs-base-l1 fw-bold mb-0 mt-base-u0">
          {{ header || 'COMMON.Confirm' | translate }}
        </h4>
      </div>
    </ng-template>
  </ng-template>
  <ng-template appCustomModalBody>
    <div class="modal-body p-base-u0 p-md-u8">
      @if (templateRef) {
        <ng-container [ngTemplateOutlet]="templateRef"></ng-container>
      }
      @if (title) {
        <label class="fs-u1 fs-lg-u2 fw-md-medium text-center mb-1">{{
          title
        }}</label>
      }
      @if (subtitle) {
        <label
          class="fs-l2 fw-normal text-center text-gray-neutrals mb-0"
          >{{ subtitle }}</label
        >
      }
    </div>
  </ng-template>
  <ng-template appCustomModalFooter>
    @if (!hideButton) {
      <div class="modal-footer border-0">
        <div class="d-flex align-items-center justify-content-end">
          <button
            class="btn btn-std btn-std-outline fs-base-l4 fw-semibold mx-1 py-base-l8 px-base-l4"
            type="button"
            [ladda]="isLoading"
            (click)="onDismissClick()"
          >
            {{ dismissText }}
          </button>
          <button
            class="btn btn-std btn-std-prim no-hover fs-base-l4 fw-semibold mx-1 py-base-l8 px-base-l0"
            type="button"
            [disabled]="isSubmitDisabled"
            [ladda]="isLoading"
            (click)="onSubmitClick()"
          >
            {{ submitText }}
          </button>
        </div>
      </div>
    }
  </ng-template>
</app-modal-confirmation>
